import SpecialSalaryPatternInputForm from './SpecialSalaryPatternInputForm';

export default SpecialSalaryPatternInputForm;
